import { useCallback } from 'react';

import { useSubmitCareerExerciseMutation, CareerLessonDetailDocument } from 'core/graphql';

import { IExerciseSubmitResult, transformExerciseSubmitResult } from './transform';

/**
 * ТЗ 0039 — сдача анкеты урока.
 *
 * После успеха перечитываем ИМЕННО этот урок: сдача засчитывает его и
 * открывает следующий, поэтому страница обязана увидеть новое состояние
 * замка. Перечитываем по документу с ТЕМИ ЖЕ переменными — рефетч по имени
 * операции промахивается молча, если запрос где-то ещё вызван с другими
 * аргументами (шрам ТЗ 0033).
 *
 * Ошибка транспорта или отказ в доступе (GraphQL-ошибка, не `customErrors`)
 * возвращается как неуспех без кода — форма покажет общий перевод. Раньше
 * исключение улетало из обработчика клика, и студент не видел ничего.
 */
export const useSubmitCareerExercise = (lessonId?: string) => {
  const [submit, { loading }] = useSubmitCareerExerciseMutation();

  const submitExercise = useCallback(
    async (answers: { fieldId: string; value: string }[]): Promise<IExerciseSubmitResult> => {
      try {
        const { data } = await submit({
          variables: { lessonId: lessonId ?? '', answers },
          refetchQueries: lessonId
            ? [{ query: CareerLessonDetailDocument, variables: { id: lessonId } }]
            : [],
          awaitRefetchQueries: true,
        });
        return transformExerciseSubmitResult(data);
      } catch {
        return transformExerciseSubmitResult(null);
      }
    },
    [submit, lessonId],
  );

  return { submitExercise, submitting: loading };
};
